import { render } from "./CogsDataRow.vue?vue&type=template&id=325c0263&scoped=true"
import script from "./CogsDataRow.vue?vue&type=script&lang=js"
export * from "./CogsDataRow.vue?vue&type=script&lang=js"

import "./CogsDataRow.vue?vue&type=style&index=0&id=325c0263&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c0263"]])

export default __exports__